import { useMemoizedFn } from 'ahooks';
import { isString } from 'lodash-es';

const regexp =
  // eslint-disable-next-line no-useless-escape
  /(https?:\/\/)(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()'@:%_\+.~#?!&//=]*)/gi;

export const useTextURLExtract = () => {
  const extract = useMemoizedFn((text?: string) => {
    const urls = text && isString(text) ? text.match(regexp) : [];
    if (text && urls && urls.length > 0) {
      const escapedURLs = urls.map((str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
      const regexString = escapedURLs.join('|');
      const regex = new RegExp(`(${regexString})`);
      const result = text.split(regex);
      return result;
    }

    return text;
  });

  const isLink = useMemoizedFn((text: string) => {
    return text.startsWith('http');
  });

  return {
    extract,
    isLink,
  };
};
